import { extendTheme } from '@chakra-ui/react';
import { buttonTheme } from './buttonTheme';
import { checkboxTheme } from './checkboxTheme';
import { formTheme } from './formTheme';
import { inputTheme } from './inputTheme';
import { listItemTheme } from './listItemTheme';
import { modalTheme } from './modalTheme';
import { radioTheme } from './radioTheme';
import { switchTheme } from './switchTheme';

const baseTheme = extendTheme({
  breakpoints: {
    sm: '320px',
    md: '768px',
    lg: '960px',
    xl: '1200px',
    '2xl': '1536px',
  },

  fonts: {
    heading: 'Primary Bold',
    body: 'Primary Regular',
  },

  sizes: {
    container: {
      xl: '1196px',
    },
  },
  colors: {
    primaryColor: '#32922A',
    primaryColor_hover: '#007939',
    primaryColor_active: '#32922A99',
    primaryColor_opacity: '#32922A33',
    secondaryColor: '#FFC000',
    selectionColor: '#32922A',
    titleColor: '#1d1d1b',
    backButtonColor: '#32922A',
    footerColor: '#707070',
    unactiveColor: '#FFC000',
    reno: {
      bg: '#ffffff',
      orange: '#D96F0E',
      yellow: '#FFC000',
      blue: '#003877',
      white: '#ffffff',
      green: '#32922A',
      pink: '#fbd7c9',
      pink40: '#fdefe9',
      black: '#1d1d1b',
      grey100: '#f1f1f1',
      grey200: '#707070',
      grey300: '#c4c4c4',
      grey400: '#E5E5E5',
      grey500: '#f9f9f8',
      red50: '#feb3b3',
      red: '#B53F3A',
      success: '#9CC813',
      selected: '#d0efce',
      selected_text: '#165410',
    },
    rossel: {
      blue: '#003877',
      blue_hover: '#3272bb',
    },
    grey: {
      50: '#E2E8F0',
      100: '#f1f1f1',
      400: '#c4c4c4',
      900: '#707070',
    },
    error: {
      100: '#FFEFF1',
      400: '#d9878b',
      900: '#B42025',
    },
    success: {
      100: '#d6dfbb',
      400: '#9cc813',
      900: '#9CC813',
    },
    warning: {
      100: '#f2ebce',
      400: '#f8d567',
      900: '#ffc000',
    },
    checkBox: {
      500: '#fbd7c9', // you need this
    },
  },

  shadows: {
    base: '0px 2px 3px rgba(0, 0, 0, 0.119509), 0px 8px 14px rgba(74, 74, 87, 0.08)',
    blur: '0px 0px 5px rgba(0, 0, 0, 0.119509), 0px 0px 14px rgba(74, 74, 87, 0.08)',
    outline: '0 0 0 3px red',
    card: '0px 0px 10px rgba(0, 0, 0, 0.119509), 0px 0px 20px rgba(74, 74, 87, 0.08)',
  },
  radii: {
    base: '5px',
  },
  styles: {
    global: {
      body: {
        bg: 'reno.bg',
        color: 'reno.black',
        fontSize: '16px',
      },
    },
  },

  components: {
    Heading: {
      baseStyle: {
        fontWeight: 'normal',
      },
    },

    IconButton: {
      baseStyle: {
        color: 'white',
        borderRadius: '25px',
        bg: 'none',
        bgColor: 'blue',
        padding: '0px',
      },
      variants: {
        default: {
          bg: 'red',
          bgColor: 'red',
        },
      },
    },

    Tooltip: {
      baseStyle: {
        color: 'white',
        bgColor: 'primary',
        bg: 'primary',
      },
    },

    Button: buttonTheme,
    Radio: radioTheme,
    Switch: switchTheme,
    Modal: modalTheme,
    List: listItemTheme,
    Checkbox: checkboxTheme,
    Input: inputTheme,
    Form: formTheme,
  },
});

// export default getTheme;
export default baseTheme;
